import { TableHeadCell } from "@shared/primitive-components"

export const distanceSpentSpeedingHeaderProps = {
  header: `Miles spent speeding`,
  tooltipContent: `The percentage of total miles this vehicle spent above the speed limit in the last 30 days.`,
}

export const DistanceSpentSpeedingHeader = () => <TableHeadCell {...distanceSpentSpeedingHeaderProps} />
